// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addProductStyle_invalidDataError__D84x+"};